import { gql } from '@apollo/client';
import { CONVERSATION_FIELDS_FRAGMENT } from './conversationFieldsFragment.gql';

const CONVERSATION_CREATE_SUBSCRIPTION = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  subscription onCreateConversation($input: ConversationSubscriptionFilterInput) {
    onCreateConversation(input: $input) {
      ...ConversationFields
    }
  }
`;

const CONVERSATION_UPDATE_SUBSCRIPTION = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  subscription onUpdateConversation($input: ConversationSubscriptionFilterInput) {
    onUpdateConversation(input: $input) {
      ...ConversationFields
    }
  }
`;

const CONVERSATION_ENTER_SUBSCRIPTION = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  subscription onEnterConversation($input: ConversationSubscriptionFilterInput) {
    onEnterConversation(input: $input) {
      ...ConversationFields
    }
  }
`;

const CONVERSATION_LEAVE_SUBSCRIPTION = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  subscription onLeaveConversation($input: ConversationSubscriptionFilterInput) {
    onLeaveConversation(input: $input) {
      ...ConversationFields
    }
  }
`;

export {
  CONVERSATION_CREATE_SUBSCRIPTION,
  CONVERSATION_UPDATE_SUBSCRIPTION,
  CONVERSATION_ENTER_SUBSCRIPTION,
  CONVERSATION_LEAVE_SUBSCRIPTION,
};
